import {
  Box,
  Button,
  Card,
  FormControl,
  FormGroup,
  Grid,
  IconButton,
  Modal,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { SubmitHandler, useForm } from "react-hook-form";
import { drawdownComparisonEditModalStyles } from "../../../styles/DrawdownComparisonChart.styles";

interface Props {
  isOpened: boolean;
  onClose: () => void;
  maxDrop: number;
  onMaxDropChange: (maxDrop: number) => void;
}

interface MaxDropInputs {
  maxDrop: number;
}

const defaultValues: MaxDropInputs = {
  maxDrop: 20,
};

export const DrawdownComparisonEditModal = ({
  isOpened,
  onClose,
  maxDrop,
  onMaxDropChange,
}: Props) => {
  const { register, handleSubmit, reset } = useForm<MaxDropInputs>({
    defaultValues: { maxDrop },
  });

  const closeModal = () => {
    onClose();
    reset({ maxDrop });
  };

  const handleFormSubmit: SubmitHandler<MaxDropInputs> = (data) => {
    onMaxDropChange(data.maxDrop);
    closeModal();
  };

  useEffect(() => {
    reset({ maxDrop });
  }, [maxDrop, reset]);

  return (
    <Modal open={isOpened} onClose={closeModal}>
      <Stack height="100%" alignItems="center" justifyContent="center">
        <Box
          sx={drawdownComparisonEditModalStyles.modalContainer}
          component="form"
          onSubmit={handleSubmit(handleFormSubmit)}
        >
          <Card>
            <Grid container justifyContent="space-between" alignItems="center">
              <Grid item>
                <Typography variant="h5" component="h5" sx={{ padding: 1 }}>
                  Edit Drawdown Limit
                </Typography>
              </Grid>
              <Grid item>
                <IconButton onClick={closeModal} aria-label="Close modal">
                  <CloseIcon />
                </IconButton>
              </Grid>
            </Grid>
            <FormGroup>
              <FormControl sx={{ margin: 1 }}>
                <TextField
                  label="Maximum Drop (%)"
                  type="number"
                  inputProps={{ step: "1", min: "1" }}
                  {...register("maxDrop", {
                    required: true,
                    valueAsNumber: true,
                    min: {
                      value: 1,
                      message: "Maximum drop must be at least 1%",
                    },
                  })}
                  helperText={`Current maximum drop: ${maxDrop.toFixed(1)}%`}
                />
              </FormControl>
              <Box sx={drawdownComparisonEditModalStyles.buttonsContainer}>
                <Button
                  type="button"
                  variant="outlined"
                  onClick={closeModal}
                  sx={drawdownComparisonEditModalStyles.button}
                >
                  Cancel
                </Button>
                <Button
                  type="submit"
                  variant="contained"
                  sx={drawdownComparisonEditModalStyles.button}
                >
                  Save
                </Button>
              </Box>
            </FormGroup>
          </Card>
        </Box>
      </Stack>
    </Modal>
  );
};
